const AppLayout = ({ isAuthenticated, children }) => {
  return <>{children}</>;
};

export default AppLayout;
